import { api } from '@lib/http';
import * as TYPES from './types';

export function setAlert(name, value) {
    return {
        payload: {
            name,
            value,
        },
        type: TYPES.ALERT_SET_ITEMS,
    };
}

export async function refreshAlerts(dispatch) {
    const alert = await api.get('/alerts');

    dispatch(setAlert('unread_redo_request_count', alert.data.unread_redo_request_count));
}
